<template>
  <div class="prose max-w-screen-sm">
    <template v-if="!institutionLinked">
      <p>{{ t('instructions.institutionNotLinked') }}</p>
      <i18n-t keypath="instructions.institutionAdmin" tag="p">
        <template #support>
          <s-link href="mailto:support@stemble.com" external class="link">
            {{ t('supportEmail') }}
          </s-link>
        </template>
      </i18n-t>
    </template>
    <template v-else-if="canCreate">
      <p>{{ t('instructions.courseNotLinked') }}</p>
      <i18n-t keypath="instructions.launchFromLms" tag="p">
        <template #support>
          <s-link href="mailto:support@stemble.com" external class="link">
            {{ t('supportEmail') }}
          </s-link>
        </template>
      </i18n-t>
    </template>
    <template v-else>
      {{ t('permissions.cannotCreate') }}
    </template>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import SLink from '../../components/SLink.vue';

defineProps<{
  canCreate: boolean;
  institutionLinked: boolean;
}>();

const {t} = useI18n();
</script>

<i18n>
{
  "en": {
    "permissions": {
      "cannotCreate": "You do not have permission to create an LTI course link."
    },
    "instructions": {
      "institutionNotLinked": "Your LMS is not currently linked to Stemble.",
      "institutionAdmin": "Please contact an IT administrator at your institution to have them create a link from your LMS to Stemble. Direct them to contact us at {support} for assistance.",
      "courseNotLinked": "This course has not yet been linked to your LMS.",
      "launchFromLms": "To create a link, launch this course from your LMS. You will be presented with a page where you can create the link. Contact {support} if you need assistance.",
    }
  },
  "fr": {
    "permissions": {
      "cannotCreate": "Vous n'avez pas la permission de créer un lien de cours LTI."
    },
    "instructions": {
      "institutionNotLinked": "Votre LMS n'est pas actuellement lié à Stemble.",
      "institutionAdmin": "Veuillez contacter un administrateur informatique de votre établissement pour qu'il crée un lien de votre LMS vers Stemble. Demandez-lui de nous contacter à {support} pour obtenir de l'aide.",
      "courseNotLinked": "Ce cours n'a pas encore été lié à votre LMS.",
      "launchFromLms": "Pour créer un lien, lancez ce cours depuis votre LMS. Une page vous sera présentée où vous pourrez créer le lien. Contactez {support} si vous avez besoin d'aide."
    }
  }
}
</i18n>
